import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, ListGroup, ListGroupItem, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import SimpleBar from "simplebar-react";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetAttScheduleState, getAttSchedule } from "../../../store/attSchedule/action";
import { resetPayrollComponentState, getPayrollComponent } from "../../../store/payrollComponent/action";
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { resetWorkGroupDetailState, getWorkGroupDetail as onGetWorkGroupDetails, addNewWorkGroupDetail as onAddNewWorkGroupDetail, updateWorkGroupDetail as onUpdateWorkGroupDetail, deleteWorkGroupDetail as onDeleteWorkGroupDetail, getWorkGroupDetailLoading } from "../../../store/workGroupDetail/action";

import { getWorkGroup as onGetWorkGroups, addNewWorkGroup as onAddNewWorkGroup, updateWorkGroup as onUpdateWorkGroup, deleteWorkGroup as onDeleteWorkGroup, getWorkGroupLoading, resetWorkGroupState } from "../../../store/workGroup/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import defaultImg from "../../../assets/images/upload.png";
import imgNotFound from "../../../assets/images/users/img-remove.png";
import { api } from "../../../config";

const WorkGroup = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [companyName, setCompanyName] = useState({});
  const [company, setCompany] = useState("");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, workGroups, isWorkGroupCreated, isWorkGroupSuccess, loading, error, workGroupDetails, workGroupDetailLoading, isWorkGroupDetailCreated, isWorkGroupDetailSuccess, attSchedules, attScheduleLoading, companies, companyLoading, employees, employeeLoading, payrollComponents, payrollComponentLoading, positions, positionLoading, accAccounts } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    workGroups: state.WorkGroup.workGroups,
    isWorkGroupCreated: state.WorkGroup.isWorkGroupCreated,
    isWorkGroupSuccess: state.WorkGroup.isWorkGroupSuccess,
    loading: state.WorkGroup.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.WorkGroup.error,
    attSchedules: state.AttSchedule.attSchedules,
    attScheduleLoading: state.AttSchedule.loading,
    workGroupDetails: state.WorkGroupDetail.workGroupDetails,
    workGroupDetailLoading: state.WorkGroupDetail.loading,
    isWorkGroupDetailCreated: state.WorkGroupDetail.isWorkGroupDetailCreated,
    isWorkGroupDetailSuccess: state.WorkGroupDetail.isWorkGroupDetailSuccess,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    payrollComponents: state.PayrollComponent.payrollComponents,
    payrollComponentLoading: state.PayrollComponent.loading,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    accAccounts: state.AccAccount.accAccounts,
  }));

  const [workGroupList, setWorkGroupList] = useState([]);
  const [workGroup, setWorkGroup] = useState([]);
  const [groupDetailAddedId, setGroupDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [infoList, setInfoList] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [workGroupDetail, setWorkGroupDetail] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [scheduleList, setScheduleList] = useState([]);
  const [componentList, setComponentList] = useState([]);
  const [positionList, setPositionList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const dayName = [
    {
      options: [
        { label: "Sunday", value: "Sunday" },
        { label: "Monday", value: "Monday" },
        { label: "Tuesday", value: "Tuesday" },
        { label: "Wednesday", value: "Wednesday" },
        { label: "Thursday", value: "Thursday" },
        { label: "Friday", value: "Friday" },
        { label: "Saturday", value: "Saturday" },
      ],
    },
  ];

  const taxMethodData = [
    {
      options: [
        { label: "Tanpa Pajak", value: "No Tax" },
        { label: "Gaji Bersih", value: "Nett" },
        { label: "Gaji Kotor", value: "Gross" },
        { label: "Gross Up", value: "Gross Up" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const [filterDate, setFilterDate] = useState(null);

  const onClickDelete = (workGroup) => {
    setWorkGroup(workGroup);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (workGroupDetail) => {
    setWorkGroupDetail(workGroupDetail);
    setDeleteModalDetail(true);
    return false;
  };

  const handleDeleteWorkGroup = () => {
    if (workGroup) {
      dispatch(onDeleteWorkGroup(workGroup));
      setDeleteModal(false);
    }
  };

  const handleDeleteWorkGroupDetail = () => {
    if (workGroupDetail) {
      setGroupDetailAddedId(workGroupDetail.groupId);
      dispatch(onDeleteWorkGroupDetail(workGroupDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setWorkGroup(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredWorkGroups = workGroups;
      if (type !== "all") {
        filteredWorkGroups = workGroups.filter((workGroup) => workGroup.wg_status.name === type);
      }
      setWorkGroupList(filteredWorkGroups);
    }
    else {
      setWorkGroupList([]);
    }
  };

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetWorkGroupState());
      dispatch(onGetWorkGroups({ companyId: companySelected?.value ?? "" }));
      dispatch(resetPayrollComponentState());
      dispatch(getPayrollComponent({ companyId: companySelected?.value ?? "", status: 2 }));
      dispatch(resetAttScheduleState());
      dispatch(getAttSchedule({ companyId: companySelected?.value ?? "", status: 2 }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(workGroups)) {
      setIsEdit(false);
      let filteredWorkGroups = workGroups;
      if (activeTypeTab !== "all") {
        filteredWorkGroups = workGroups.filter((workGroup) => workGroup.wg_status.name === activeTypeTab);
      }
      setWorkGroupList(filteredWorkGroups);
      let current = 0;
      if (groupDetailAddedId !== 0) {
        workGroups.forEach((obj, i) => {
          if (obj.id === groupDetailAddedId) current = i;
        });
      }
      setInfo(workGroups[workGroups.length - 1]);
      setCompany({
        label: workGroups[workGroups.length - 1].wg_company.name,
        value: workGroups[workGroups.length - 1].wg_company.id,
      });
      setInfoList(workGroups[workGroups.length - 1].wg_detail);
    }
    else {
      setWorkGroupList([]);
    }
  }, [workGroups, groupDetailAddedId]);

  useEffect(() => {
    if (isWorkGroupDetailCreated) {
      dispatch(resetWorkGroupDetailState());
      dispatch(resetWorkGroupState());
      dispatch(onGetWorkGroups());
    }
  }, [dispatch, isWorkGroupDetailCreated]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(positions)) {
      var data = [];
      var opt = [{ label: "All Posittion", value: "All Posittion" }];
      positions.forEach((item, key) => {
        const position_name = item.name;
        const departmentId = item.departmentId;
        const name = item.position_department && item.position_department.name;
        const id = item.id;
        var obj = {
          label: position_name + ", " + name,
          value: id,
          positionId: id,
          position_name: position_name,
          departmentId: departmentId,
          name: name,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPositionList(data);
    }
  }, [positions]);

  useEffect(() => {
    var data = [];
    var opt = [];
    attSchedules.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (attSchedules.length > 0) {
      setScheduleList(data);
    }
  }, [attSchedules]);

  useEffect(() => {
    var data = [];
    var opt = [];
    payrollComponents.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (payrollComponents.length > 0) {
      setComponentList(data);
    }
  }, [payrollComponents]);

  const handleGroupDetail = useCallback(
    (arg) => {
      dispatch(resetPositionState());
      dispatch(resetEmployeeState());
      setPositionList([]);
      setEmployeeList([]);
      dispatch(getPosition({ companyId: arg, status: 2 }));
      dispatch(getEmployee({ type: "referral", status: 2, companyId: arg }));
    },
    [dispatch]
  );

  const handlePositionClick = useCallback(
    (companyId, positionId) => {
      if (positionId === null) {
        dispatch(resetEmployeeState());
        setEmployeeList([]);
        dispatch(getEmployee({ type: "referral", status: 2, companyId: companyId }));
      } else {
        if (positionId === "All Posittion") {
          dispatch(resetEmployeeState());
          setEmployeeList([]);
          dispatch(getEmployee({ type: "referral", status: 2, companyId: companyId }));
        } else {
          dispatch(resetEmployeeState());
          setEmployeeList([]);
          dispatch(getEmployee({ type: "referral", status: 2, companyId: companyId, positionId: positionId }));
        }
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [{ label: "Select All", value: "all" }];
      employees.forEach((item, key) => {
        const name = item.name;
        const id = item.userId;
        const companyId = item.companyId;
        const position = item.employee_position;
        const department = item.employee_department;
        const position_name = item?.employee_user && item?.employee_user?.user_position ? item?.employee_user?.user_position?.name : "Not set";
        var obj = {
          label: name + " - " + position_name,
          value: id,
          companyId: companyId,
          position: position,
          department: department,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setWorkGroup(null);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  const handleWorkGroupClick = useCallback(
    (arg) => {
      const data = arg;
      setWorkGroup({
        id: data.id,
        name: data.name,
        client: data.wg_client && {
          label: data.wg_client ? data.wg_client.name : "",
          value: data.wg_client ? data.wg_client.id : "",
        },
        company: data.wg_company && {
          label: data.wg_company ? data.wg_company.name : "",
          value: data.wg_company ? data.wg_company.id : "",
        },
        schedule: data.wg_schedule && {
          label: data.wg_schedule ? data.wg_schedule.name : "",
          value: data.wg_schedule ? data.wg_schedule.id : "",
        },
        component: data.wg_component && {
          label: data.wg_component ? data.wg_component.name : "",
          value: data.wg_component ? data.wg_component.id : "",
        },
        tax_method: data.tax_method && {
          label: data.tax_method,
          value: data.tax_method,
        },
        isAbsentCompensation: data.isAbsentCompensation,
        isWFA: data.isWFA,
      });

      setIsEdit(true);
      toggle();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, userType]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setWorkGroupDetail(null);
      setWorkGroup(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      setCompany({
                        label: data.wg_company.name,
                        value: data.wg_company.id,
                      });
                      handlePositionClick(data.wg_company.id, null);
                      setInfoList(data.wg_detail);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateWorkGroup") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleWorkGroupClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteWorkGroup") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveWorkGroup") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui grup kerja untuk ${data.name}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Grup",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Jadwal",
        accessor: "wg_schedule.name",
        filterable: true,
      },
      {
        Header: "Komponen",
        accessor: "wg_component.name",
        filterable: true,
      },
      {
        Header: "Pajak",
        accessor: "tax_method",
        filterable: true,
      },
      {
        Header: "Absen",
        accessor: "isAbsentCompensation",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case true:
              return <span className="badge text-uppercase badge-soft-success">Yes</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">No</span>;
          }
        },
      },
      {
        Header: "WFA",
        accessor: "isWFA",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case true:
              return <span className="badge text-uppercase badge-soft-success">Yes</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">No</span>;
          }
        },
      },
      {
        Header: "Status",
        accessor: "wg_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [handleWorkGroupClick, handlePositionClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: workGroupList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveGroup = () => {
    if (workGroup) {
      workGroup.setApprove = true;
      dispatch(onUpdateWorkGroup(workGroup));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (workGroup && workGroup.name) ?? "",
      client: (workGroup && workGroup.client) || clientSelected,
      company: (workGroup && workGroup.company) || companySelected,
      schedule: (workGroup && workGroup.schedule) ?? "",
      component: (workGroup && workGroup.component) ?? "",
      tax_method: (workGroup && workGroup.tax_method) ?? "",
      isAbsentCompensation: (workGroup && workGroup.isAbsentCompensation) || false,
      isWFA: (workGroup && workGroup.isWFA) || false,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Group Name"),
      company: Yup.object().required("Please Enter Company"),
      schedule: Yup.object().required("Please Enter Schedule"),
      component: Yup.object().required("Please Enter Component"),
      tax_method: Yup.object().required("Please Enter Tax Method"),
    }),
    onSubmit: (values) => {
      dispatch(getWorkGroupLoading());
      if (isEdit) {
        const updateWorkGroup = {
          id: workGroup ? workGroup.id : 0,
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          scheduleId: values.schedule.value,
          componentId: values.component.value,
          tax_method: values.tax_method.value,
          isAbsentCompensation: values.isAbsentCompensation,
          isWFA: values.isWFA,
        };
        dispatch(onUpdateWorkGroup(updateWorkGroup));
        validation.resetForm();
      } else {
        const newWorkGroup = {
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          scheduleId: values.schedule.value,
          componentId: values.component.value,
          tax_method: values.tax_method.value,
          isAbsentCompensation: values.isAbsentCompensation,
          isWFA: values.isWFA,
        };
        dispatch(onAddNewWorkGroup(newWorkGroup));
        validation.resetForm();
      }
      toggle();
    },
  });

  useEffect(() => { }, [workGroupList]);

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      company: company,
      position: "",
      companyId: (workGroupDetail && workGroupDetail.companyId) || (workGroup && workGroup.companyId),
      groupId: (workGroupDetail && workGroupDetail.groupId) || (workGroup && workGroup.id),
      employee: (workGroupDetail && workGroupDetail.employee) || [],
      employeeId: workGroupDetail && workGroupDetail.employeeId,
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Please Enter Company").nullable(true),
      employee: Yup.array()
        .min(1, "Pick at least 1 employee")
        .of(
          Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required(),
          })
        ),
    }),
    onSubmit: (values) => {
      setGroupDetailAddedId(values.groupId);
      dispatch(getWorkGroupLoading());
      if (isEditDetail) {
        const updateWorkGroupDetail = {
          id: workGroupDetail ? workGroupDetail.id : 0,
          employeeId: values.employeeId.value,
          groupId: values.groupId,
          // companyId: values.companyId,
        };
        dispatch(onUpdateWorkGroupDetail(updateWorkGroupDetail));
        validationDetail.resetForm();
      } else {
        const newWorkGroupDetail = {
          employee: values.employee,
          groupId: values.groupId,
          // companyId: values.companyId,
        };
        dispatch(onAddNewWorkGroupDetail(newWorkGroupDetail));
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteWorkGroupDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleWorkGroupStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetWorkGroups(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setWorkGroupList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetWorkGroupState());
    dispatch(onGetWorkGroups({ companyId: companySelected?.value ?? "" }));
  };

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return el.wgd_emp && el.wgd_emp.name && el.wgd_emp.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };

    let filterData = filterItems(info.wg_detail, inputVal);
    setInfoList(filterData);
  };

  const handleGetSchedule = (id) => {
    dispatch(resetAttScheduleState());
    dispatch(getAttSchedule({ companyId: id, status: 2 }));
  };

  const handleGetPayrollComponent = (id) => {
    dispatch(resetPayrollComponentState());
    dispatch(getPayrollComponent({ companyId: id, status: 2 }));
  };

  useEffect(() => {
    setCompanyList([]);
    setScheduleList([]);
    setComponentList([]);
  }, []);

  document.title = "Grup Kerja | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ApproveModal data={workGroup && workGroup.contract_employee ? workGroup.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveGroup} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteWorkGroup} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeleteWorkGroupDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Penggajian" pageTitle="Grup Kerja" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createWorkGroup") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={8}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA GRUP KERJA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={9}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Grup Kerja" : "Tambah Grup Kerja"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;{" "}
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;{" "}
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                setScheduleList([]);
                                validation.setFieldValue("schedule", "");
                                setComponentList([]);
                                validation.setFieldValue("component", "");
                                validation.setFieldValue("company", e);
                                handleGetSchedule(e.value);
                                handleGetPayrollComponent(e.value);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama Grup
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Grup" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="schedule-field" className="form-label">
                              Jadwal <span className="text-danger">*</span>&nbsp;
                              {attScheduleLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="schedule"
                              value={validation.values.schedule}
                              placeholder="Pilih Jadwal"
                              isDisabled={scheduleList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("schedule", e);
                              }}
                              options={scheduleList}
                            ></Select>
                            {validation.touched.schedule && validation.errors.schedule ? (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validation.errors.schedule}
                              </p>
                            ) : null}
                          </div>

                          {/* <div className="mb-3">
                            <Label htmlFor="schedule" className="form-label">
                              Schedule
                              {attScheduleLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="schedule"
                              value={validation.values.schedule}
                              placeholder="Enter Schedule"
                              onChange={(e) => {
                                validation.setFieldValue("schedule", e);
                              }}
                              options={scheduleList}></Select>
                            {validation.touched.schedule && validation.errors.schedule ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.schedule}      </small>
                            ) : null}
                          </div> */}
                          <div className="mb-3">
                            <Label htmlFor="component-field" className="form-label">
                              Komponen Gaji <span className="text-danger">*</span>&nbsp;
                              {payrollComponentLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="component"
                              value={validation.values.component}
                              placeholder="Pilih Komponen Gaji"
                              isDisabled={componentList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("component", e);
                              }}
                              options={componentList}
                            ></Select>
                            {validation.touched.component && validation.errors.component ? (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validation.errors.component}
                              </p>
                            ) : null}
                          </div>
                          {/* <div className="mb-3">
                            <Label htmlFor="component" className="form-label">
                              Payroll Component
                              {payrollComponentLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="component"
                              value={validation.values.component}
                              placeholder="Enter Component"
                              onChange={(e) => {
                                validation.setFieldValue("component", e);
                              }}
                              options={componentList}></Select>
                            {validation.touched.component && validation.errors.component ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.component}      </small>
                            ) : null}
                          </div> */}
                          <div className="mb-3">
                            <Label htmlFor="tax_method" className="form-label">
                              Metode Pajak{" "}
                            </Label>
                            <Select
                              name="tax_method"
                              value={validation.values.tax_method}
                              placeholder="Pilih Metode Pajak"
                              onChange={(e) => {
                                validation.setFieldValue("tax_method", e);
                              }}
                              options={taxMethodData}
                            ></Select>
                            {validation.touched.tax_method && validation.errors.tax_method ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.tax_method}{" "}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Input name="isAbsentCompensation" id="isAbsentCompensation-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isAbsentCompensation} /> &nbsp;
                            <Label htmlFor="isAbsentCompensation-field" className="form-label">
                              Kompensasi Absen?
                            </Label>
                          </div>
                          <div className="mb-3">
                            <Input name="isWFA" id="isWFA-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isWFA} /> &nbsp;
                            <Label htmlFor="isWFA-field" className="form-label">
                              Dapat Bekerja Dari Mana Saja?
                            </Label>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Ubah Grup" : "Tambah Grup"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      {!!isEditDetail ? (
                        <div className="row">
                          <div className="mb-3">
                            <Label htmlFor="employeeId" className="form-label">
                              Karyawan{" "}
                              {employeeLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="employeeId"
                              value={validationDetail.values.employeeId}
                              placeholder="Enter Employee"
                              onChange={(e) => {
                                validationDetail.setFieldValue("employeeId", e);
                              }}
                              options={employeeList}
                              filterOption={(option) => option.value !== "all"}
                            ></Select>
                            {validationDetail.touched.employeeId && validationDetail.errors.employeeId ? (
                              <small className="text-danger" type="invalid">
                                {validationDetail.errors.employeeId}
                              </small>
                            ) : null}
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="mb-3 col-lg-6">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;{" "}
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validationDetail.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validationDetail.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="position" className="form-label">
                              Cari Karyawan Berdasarkan Posisi{" "}
                              {positionLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="position"
                              value={validationDetail.values.position}
                              placeholder="Pilih Posisi"
                              onChange={(e) => {
                                validationDetail.setFieldValue("position", e);
                                handlePositionClick(company.value, e.value);
                              }}
                              options={positionList}
                              invalid={validationDetail.touched.position && validationDetail.errors.position ? true : false}
                            ></Select>
                            {validationDetail.touched.position && validationDetail.errors.position ? (
                              <p className="text-danger" type="invalid">
                                {validationDetail.errors.position}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="employee" className="form-label">
                              Karyawan{" "}
                              {employeeLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}{" "}
                            </Label>
                            <Select
                              name="employee"
                              placeholder="Pilih Karyawan"
                              value={validationDetail.values.employee}
                              isMulti
                              onChange={(opt, { option }) => {
                                let newOpts = opt;
                                if (option && option.value === "all") {
                                  let filteredOptions = clone(employeeList);
                                  filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                  newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                }
                                validationDetail.setFieldValue("employee", newOpts);
                              }}
                              options={employeeList}
                            ></Select>
                            {validationDetail.touched.employee && validationDetail.errors.employee ? (
                              <small className="text-danger" type="invalid">
                                {validationDetail.errors.employee}
                              </small>
                            ) : null}
                          </div>
                        </div>

                        //////////////////////////////
                      )}
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <div className="card-body d-flex align-items-center align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info.name ? info.name : " - "}</h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-success add-btn" : userRole && userRole.split(",").indexOf("createWorkGroup") !== -1 ? "btn btn-success add-btn" : "btn btn-success add-btn d-none"}
                    id="create-btn"
                    onClick={() => {
                      setWorkGroup(info);
                      handleGroupDetail(info.companyId);
                      setIsEditDetail(false);
                      toggleDetail();
                    }}
                  >
                    <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                    Tambah Detail
                  </button>
                  <button className="btn btn-soft-danger ms-2" onClick={() => setDeleteModalMulti(true)}>
                    <i className="ri-delete-bin-5-line me-1 align-bottom fs-14"></i>
                  </button>
                </div>
              </div>
              <CardBody>
                <div id="pagination-list">
                  <div className="mb-2 d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <input className="search form-control" placeholder="Cari..." onChange={(e) => searchList(e.target.value)} />
                    </div>
                  </div>
                  <SimpleBar style={{ height: "442px" }}>
                    <ListGroup className="list mb-0" flush>
                      {(infoList || []).map((row) => {
                        return (
                          <ListGroupItem className="ps-0 pe-0" key={row.id}>
                            <div className="d-flex align-items-center pagi-list">
                              <div className="flex-shrink-0 me-2">
                                <input type="checkbox" className="dataCheckbox form-check-input" value={row.id} />
                              </div>
                              <div className="flex-grow-1 overflow-hidden">
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0">
                                    {row.wgd_user !== null && row.wgd_user.image !== "" ? (
                                      <img
                                        src={api.MEDIA_URL + "/media/" + row.wgd_user.image}
                                        alt=""
                                        className="avatar-xs rounded-circle me-1"
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null; // prevents looping
                                          currentTarget.src = imgNotFound;
                                        }}
                                      />
                                    ) : (
                                      <div className="flex-shrink-0 avatar-xs me-1">
                                        <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{row.wgd_user !== null ? row.wgd_user.name.charAt(0).toUpperCase() : "-"}</div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="flex-grow-1 ms-2 name">
                                    <h5 className="fs-13 mb-1">{row.wgd_user !== null ? row.wgd_user.name : "-"}</h5>
                                    <p className="born timestamp text-muted mb-0">{row.wgd_user !== null ? row.wgd_user.user_position && row.wgd_user.user_position.name : "-"}</p>
                                  </div>
                                </div>
                              </div>
                              <div className="flex-shrink-0 ms-2">
                                <div className="hstack gap-2 mt-4 mt-sm-0">
                                  <button
                                    className="btn-icon btn btn-sm btn-soft-danger remove-item-btn btn-remove-detail"
                                    onClick={() => {
                                      onClickDeleteDetail(row);
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </ListGroupItem>
                        );
                      })}
                      <ListGroupItem></ListGroupItem>
                    </ListGroup>
                  </SimpleBar>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WorkGroup;
